/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Opens_New_TabInputs */

const en_read_opens_new_tab = /** @type {(inputs: Read_Opens_New_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`opens in a new tab`)
};

const lv_read_opens_new_tab = /** @type {(inputs: Read_Opens_New_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`atveras jaunā cilnē`)
};

/**
* | output |
* | --- |
* | "opens in a new tab" |
*
* @param {Read_Opens_New_TabInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const read_opens_new_tab = /** @type {((inputs?: Read_Opens_New_TabInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Opens_New_TabInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_read_opens_new_tab(inputs)
	return en_read_opens_new_tab(inputs)
});